import React from 'react';
import {
    Box,
    List,
    ListItemButton,
    ListItemIcon,
    Divider,
} from '@mui/material';
import StorageIcon from '@mui/icons-material/Storage';
import LastUpdate from '../last-update/LastUpdate';
import theme from '../../theme';

interface FilterDrawerContentProps {
  filterElements?: React.ReactNode;
}

export const FilterDrawerContent: React.FC<FilterDrawerContentProps> = ({ filterElements }) => {
    return (
        <Box
          role="presentation"
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          {/* Filter Items */}
          <Box sx={{ flex: '0 0 auto', p: 2 }}>
              {filterElements}
          </Box>

          {/* Spacer */}
          <Box sx={{ flex: '1 1 auto' }} />

          {/* Bottom section with LastUpdate */}
          <Divider />
          <Box sx={{ flex: '0 0 auto', backgroundColor: '#787A7E' }}>
              <List dense sx={{ py: 0 }}>
                  <ListItemButton sx={{ minHeight: 56 }}>
                      <ListItemIcon>
                          <StorageIcon sx={{ color: theme.palette.primary.contrastText }} />
                      </ListItemIcon>
                      <LastUpdate componentLocation="nav" expanded={true} />
                  </ListItemButton>
              </List>
          </Box>
      </Box>
    );
};